import React from "react";
import styles from "./Logo.module.scss";
import { colors } from "@silversea-ssc/design-system-tokens";
import { Icon } from "../Icon/Icon";
import { BackgroundColor } from "../Backgrounds/background";

export interface LogoProps {
  width?: number;
  mobileWidth?: number;
  color?: BackgroundColor | "currentColor";
}

const Logo: React.FC<React.PropsWithChildren<LogoProps>> = ({
  width = 200,
  mobileWidth = 130,
  color = "white"
}) => {
  const colorCode = colors[color];

  const stylesVariables = {
    "--icon-color": colorCode,
    "--icon-desktop-width": `${width}px`,
    "--icon-mobile-width": `${mobileWidth || width}px`
  } as React.CSSProperties;

  return (
    <div style={stylesVariables}>
      <Icon
        name="logo"
        className={styles.icon}
        wrapperClassName={styles.wrapper}
        padding={false}
      />
    </div>
  );
};

export { Logo };
export default Logo;
